import stopAnimationsIcon from "../icons/stopAnimationsIcon.svg"
import hideImagesIcon from "../icons/hideImagesIcon.svg"
import imageTooltipsIcon from "../icons/imageTooltipsIcon.svg"

export default [
    {
        label: 'Stop Animations',
        key: 'stop-animations',
        icon: stopAnimationsIcon,
    },
    {
        label: 'Hide Images',
        key: 'hide-images',
        icon: hideImagesIcon,
    },
    {
        label: 'Image Tooltips',
        key: 'image-tooltips',
        icon: imageTooltipsIcon,
    },
]
